import React, { useState, useEffect, useContext } from "react";
import { Upload, message, Image, Space } from "antd";
import PsContext from "../context";
import { LoadingOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import ImgCrop from "antd-img-crop";
import "./style.css";

const ImageUpload = (props) => {
  const context = useContext(PsContext);
  //type=add or edit

  const {
    storeFileName,
    allowPDF,
    defaultImage,
    onFinish,
    cropRatio,
    isAddOnly,
    ...other
  } = props;

  const [imgLoading, setImgLoading] = useState(false);
  const [storingFile, setStoringFile] = useState("");
  const [originalFileName, setOriginalFileName] = useState("");
  const [imageUrl, setImageUrl] = useState();

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const beforeUpload = (file) => {
    let isJpgOrPngOrPdf =
      file.type === "image/jpeg" || file.type === "image/png";
    if (allowPDF && file.type == "application/pdf") isJpgOrPngOrPdf = true;

    if (!isJpgOrPngOrPdf) {
      message.error(
        allowPDF
          ? "You can only upload JPG/PNG/PDF files!"
          : "You can only upload JPG/PNG files!"
      );
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isLt2M) {
      message.error("File must smaller than 2MB!");
    }
    if (isJpgOrPngOrPdf && isLt2M) UploadFile(file);
    return isJpgOrPngOrPdf && isLt2M;
  };

  const handleFileChange = (info) => {
    /*  if (info.file.status === 'uploading') {
            setImgLoading(true);
            setImageUrl(false);
            return;
        } */
  };

  const UploadFile = (file) => {
    setImageUrl("");
    setOriginalFileName("");
    getBase64(file, (data64) => {
      var form = new FormData();
      form.append("file_data", data64);
      form.append("file_name", file.name);
      const storeFileName2 =
        file.type == "application/pdf"
          ? storeFileName + ".pdf"
          : storeFileName + ".jpg";
      setStoringFile(storeFileName2);
      setOriginalFileName(file.name);
      form.append("store_file_name", storeFileName2);
      context.psGlobal
        .apiRequest("v1/admin/upload-image", "prod", form)
        .then((res, error) => {
          if (res) {
            setImgLoading(false);
            if (allowPDF && file.type == "application/pdf") setImageUrl("");
            else setImageUrl(context.baseUrl + storeFileName2);
            onFinish(storeFileName2);
          } else {
            message.error(error);
          }
        });
    });
  };

  const uploadButton = (
    <div>
      {imgLoading ? (
        <LoadingOutlined />
      ) : defaultImage && defaultImage !== "" ? (
        <EditOutlined />
      ) : (
        <PlusOutlined />
      )}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {defaultImage && defaultImage !== "" ? "Change" : "Upload"}
      </div>
    </div>
  );

  return (
    <>
      <Space>
        {defaultImage && (
          <Image height={200} src={context.baseUrl + defaultImage}></Image>
        )}
        {/* {grid rotate aspectSlider aspect={parseInt(cropRatio.split("/")[0])/parseInt(cropRatio.split("/")[1])}} */}
        {cropRatio && (
          <ImgCrop aspectSlider showGrid rotationSlider>
            <Upload
              {...other}
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              action={(file) => {
                //  UploadFile(file)
              }}
              beforeUpload={beforeUpload}
              onChange={handleFileChange}
            >
              {imageUrl && !isAddOnly ? (
                <img
                  src={imageUrl}
                  alt="avatar"
                  style={{
                    width: "100%",
                  }}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </ImgCrop>
        )}
        {!cropRatio && (
          <>
            <Upload
              {...other}
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              action={(file) => {
                //  UploadFile(file)
              }}
              beforeUpload={beforeUpload}
              onChange={handleFileChange}
            >
              {imageUrl && !isAddOnly ? (
                <img
                  src={imageUrl}
                  alt="avatar"
                  style={{
                    width: "100%",
                  }}
                />
              ) : storingFile && storingFile.includes(".pdf") ? (
                <FontAwesomeIcon icon={faFilePdf} size="3x" />
              ) : (
                uploadButton
              )}
            </Upload>
          </>
        )}
      </Space>
      <br />
      {storingFile && storingFile.includes(".pdf")
        ? "Selected PDF: " + originalFileName
        : ""}
    </>
  );
};

export { ImageUpload };
